import React from 'react';
import ContentLoader from 'react-content-loader';

const PostListLoader = () => (
  <div className="results-posts">
    {[...Array(5)].map((_, i) => (
      <div className="results-post" key={`loading-post-${i}`}>
        <ContentLoader
          ariaLabel={false}
          height={90}
          preserveAspectRatio="xMaxYMax"
          uniquekey={`loading-svg-${i}`}
        >
          <rect height="4.224" rx="4"
            ry="4" width="77.22"
            x="49.31" y="12.92" />
          <rect height="4.032" rx="3"
            ry="3" width="53.55"
            x="49.31" y="26.15" />
          <rect height="9.920000000000002" rx="3"
            ry="3" width="231"
            x="3" y="45.37" />
          <rect height="4.224" rx="3"
            ry="3" width="360"
            x="3" y="69.15" />
          <rect height="4.224" rx="3"
            ry="3" width="200"
            x="3" y="82.39" />
          <circle cx="19.5" cy="19.5"
            r="16.5" />
        </ContentLoader>
      </div>
    ))}
  </div>
);

export default PostListLoader;
